import { render, staticRenderFns } from "./MeasurementsMenu.vue?vue&type=template&id=4709d9d9&scoped=true"
import script from "./MeasurementsMenu.vue?vue&type=script&lang=js"
export * from "./MeasurementsMenu.vue?vue&type=script&lang=js"
import style0 from "./MeasurementsMenu.vue?vue&type=style&index=0&id=4709d9d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4709d9d9",
  null
  
)

export default component.exports